.root {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;

  h2 {
    min-width: 200px;
    text-align: center;
  }
}

/* TODO: fix the table rendering */
